require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-37-best-food-and-drink-e-commerce-websites.json") })
        }
      }, "path---blog-37-best-food-and-drink-e-commerce-websites");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-37-best-food-and-drink-e-commerce-websites!./.cache/json/blog-37-best-food-and-drink-e-commerce-websites.json
// module id = 393
// module chunks = 231608221292675